import Head from "next/head";
import { useEffect } from "react";
import Layout from "../components/Layout";
import Loader from "../components/Loader";
import PremiumPlanCards from "../components/PremiumPlanCards";
import PremiumPlansPageHeader from "../components/PremiumPlansPageHeader";
import PremiumPerks from "../components/PremiumPerks";
import useAllCrditSkusStore from "../zustandStores/allCreditSkus";
import classes from "./css/plan-selection.module.css";
import ContactSales from "../components/ContactSales";
import PremiumPlanFaq from "../components/PremiumPlanFaq";
import LogService from "../services/LogService";
import CREDIT_EVENTS from "../utils/CreditEvents";
import ScreenError from "../components/ScreenError";
import PromotionBanner from "../components/PromotionBanner";

export default function PlanSelectionPage(props) {
  const { fetchData, fetchedState } = useAllCrditSkusStore(state => ({
    fetchData: state.fetchData,
    fetchedState: state.fetchedState
  }));

  useEffect(() => {
    fetchData();
    LogService.log(CREDIT_EVENTS.PLAN_SELECTION_PAGE_LANDED, {
      trackSource: true
    });
  }, []);

  return (
    <>
      <Head>
        <title>Job Hai - Premium plan selection</title>
      </Head>
      <Layout isFooter={false} isLogin={true} isHeaderFixed={true}>
        {fetchedState === "LOADING" ? <Loader /> : null}
        {fetchedState === "ERROR" ? <ScreenError /> : null}
        {fetchedState === "SUCCESS" ? (
          <div className={classes.root}>
            <PromotionBanner source="PLAN_SELECTION" />
            <PremiumPlansPageHeader />
            <PremiumPlanCards />
            <ContactSales />
            <PremiumPerks />
            <PremiumPlanFaq />
          </div>
        ) : null}
      </Layout>
    </>
  );
}
